import { render, staticRenderFns } from "./ShifokorTash.vue?vue&type=template&id=a626561e"
import script from "./ShifokorTash.vue?vue&type=script&lang=js"
export * from "./ShifokorTash.vue?vue&type=script&lang=js"
import style0 from "./ShifokorTash.vue?vue&type=style&index=0&id=a626561e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports